import { createSlice } from '@reduxjs/toolkit';

// Load initial state from localStorage
const loadFromLocalStorage = () => {
    try {
        const serializedState = localStorage.getItem('mindMaps2');
        if (serializedState === null) {
            return {
                mindMaps: {},
                currentMindMapId: 'default',
                lastSaved: null
            };
        }
        return JSON.parse(serializedState);
    } catch (err) {
        console.error('Error loading mind maps from localStorage:', err);
        return {
            mindMaps: {},
            currentMindMapId: 'default',
            lastSaved: null
        };
    }
};

const initialState = loadFromLocalStorage();

const mindSlice2 = createSlice({
    name: 'mind2',
    initialState,
    reducers: {
        saveMindMap: (state, action) => {
            const { id, nodes } = action.payload;
            state.mindMaps[id] = {
                nodes,
                lastModified: new Date().toISOString()
            };
            state.currentMindMapId = id;
            state.lastSaved = new Date().toISOString();

            // Save to localStorage
            try {
                localStorage.setItem('mindMaps2', JSON.stringify(state));
            } catch (err) {
                console.error('Error saving mind map to localStorage:', err);
            }
        },
        loadMindMap: (state, action) => {
            state.currentMindMapId = action.payload;

            // Save to localStorage
            try {
                localStorage.setItem('mindMaps2', JSON.stringify(state));
            } catch (err) {
                console.error('Error saving to localStorage:', err);
            }
        },
        deleteMindMap: (state, action) => {
            const id = action.payload;
            delete state.mindMaps[id];
            if (state.currentMindMapId === id) {
                state.currentMindMapId = 'default';
            }

            // Save to localStorage
            try {
                localStorage.setItem('mindMaps2', JSON.stringify(state));
            } catch (err) {
                console.error('Error saving to localStorage:', err);
            }
        },
        setCurrentMindMapId: (state, action) => {
            state.currentMindMapId = action.payload;

            // Save to localStorage
            try {
                localStorage.setItem('mindMaps2', JSON.stringify(state));
            } catch (err) {
                console.error('Error saving to localStorage:', err);
            }
        },
        createNewMindMap: (state, action) => {
            const { id, nodes } = action.payload;
            state.mindMaps[id] = {
                nodes,
                lastModified: new Date().toISOString()
            };
            state.currentMindMapId = id;

            // Save to localStorage
            try {
                localStorage.setItem('mindMaps2', JSON.stringify(state));
            } catch (err) {
                console.error('Error saving to localStorage:', err);
            }
        }
    }
});

export const {
    saveMindMap,
    loadMindMap,
    deleteMindMap,
    setCurrentMindMapId,
    createNewMindMap
} = mindSlice2.actions;

// Selectors
export const selectMindMaps = (state) => state.mind2?.mindMaps || {};
export const selectCurrentMindMapId = (state) => state.mind2?.currentMindMapId || 'default';
export const selectCurrentMindMap = (state) => {
    const id = state.mind2?.currentMindMapId || 'default';
    return state.mind2?.mindMaps?.[id] || null;
};
export const selectLastSaved = (state) => state.mind2?.lastSaved;

export default mindSlice2.reducer;
